// extracted by mini-css-extract-plugin
export default {"links":"Inventory_links__Gy1N+"};